export default __webpack_public_path__ + "static/media/pure-gas-banner.84de4e3c.jpg";